import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { DashWrapper } from "components/DashboardContainer/UnauthenticatedDash";
import { Spinner } from "@kui-react/spinner";
import { useKas } from "contexts/KasContext";
import { AGENT_LAUNCHABLE_IDS } from "constants/agentLaunchables";

const launchableId = AGENT_LAUNCHABLE_IDS.nemoclaw;

const NemoClawRedirect: React.FC = () => {
  const history = useHistory();
  const { isUserLoggedIn, isLoading: isAuthLoading } = useKas();

  useEffect(() => {
    if (isAuthLoading) return;

    if (launchableId) {
      const deployPath = isUserLoggedIn
        ? `/launchable/deploy/now?launchableID=${launchableId}`
        : `/launchable/deploy?launchableID=${launchableId}`;
      history.replace(deployPath);
    } else {
      history.replace("/launchables");
    }
  }, [isAuthLoading, isUserLoggedIn]);

  return (
    <DashWrapper>
      <div className="h-screen flex justify-center items-center">
        <Spinner />
      </div>
    </DashWrapper>
  );
};

export default NemoClawRedirect;
